import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CheckPermission } from 'src/app/models/checkPermission';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { Router } from '@angular/router';

@Directive({
  selector: '[checkPermission]',
})
export class CheckPermissionDirective implements OnInit {
  // the role the user must have
  @Input('checkPermission') set checkPermission(permission: CheckPermission) {
    this.isGranted(permission);
  }
  ngOnInit() {}
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private router: Router
  ) {}

  private isGranted(permission: CheckPermission) {
    let localPermission = localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS);
    if(localPermission == null){
      return ;
    }
    let permissions = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS)).permissions;
    let permissions_dot_annotation = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS_DOT_ANNOTATION))
      .permissions;
    // if admin or we are not sending permission object, show screen
    if (!permission) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      return;
    }
    // if no permissions in local storage and user is not admin dont show
    if (!permissions && JSON.parse(localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS)).role != 'Admin') {
      this.viewContainerRef.clear();
    } else if (
      permission.type == 'ADMIN' &&
      JSON.parse(localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS)).role === 'Admin'
    ) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }

    // if type is context we are searching if user has anywhere set manager permission. any subsection, any section. it is easier to use dot annotation her
    // used to render admin menu for users that have set something to manager
    else if (permission.type == 'CONTEXT') {
      let managerPermissions = Object.keys(permissions_dot_annotation).filter(
        (val) => permissions_dot_annotation[val] == 'MANAGER'
      );
      let managerPermissionInSubsection = false;

      managerPermissions.forEach((el) => {
        if (el.includes('subsection')) {
          managerPermissionInSubsection = true;
        }
      });
      if (managerPermissionInSubsection) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    }

    // if pertinince is persona, we have one nested level less then other pertinences
    if (permission.pertinence == 'persona' && permissions[permission.pertinence]) {
      if (
        permission.type == 'MANAGER' &&
        permissions[permission.pertinence][permission.context] &&
        permissions[permission.pertinence][permission.context] == 'MANAGER'
      ) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    }
    // if pertinence is not persona, for now only subsectin exists
    else if (permission.pertinence == 'subsection' && permissions[permission.pertinence]) {
      // if sending permission type = section, we are rendering navbar big and navbar small menu items
      if (permission.type == 'SECTION' && permissions[permission.pertinence][permission.section]) {
        let showView = false;
        for (const key of Object.keys(permissions[permission.pertinence][permission.section])) {
          for (const contextKey of Object.keys(permissions[permission.pertinence][permission.section][key])) {
            if (contextKey == 'metadata') {
              showView = true;
              break;
            }
          }
        }
        if (showView) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      } else if (permission.type == 'SUBSECTION' && permissions[permission.pertinence][permission.section]) {
        // Seems this section are user only for Administrator permessions on tabs, then i added a specifi control for check if tab button is needed or not APC-800
        const subsection_permissions = permissions.subsection[permission.section];
        let haveMangerForSomeone = false;

        for (let subsection_permissions_key of Object.keys(subsection_permissions)) {
          const subsection_permissions_node = subsection_permissions[subsection_permissions_key];
          for (let subkeys of Object.keys(subsection_permissions_node)) {
            if (subsection_permissions_node[subkeys] === 'MANAGER') {
              haveMangerForSomeone = true;
              break;
            }
          }
        }

        if (haveMangerForSomeone) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      } else if (
        permission.type == 'READER' &&
        permissions[permission.pertinence] &&
        permissions[permission.pertinence][permission.section] &&
        permissions[permission.pertinence][permission.section][permission.subsection] &&
        (permissions[permission.pertinence][permission.section][permission.subsection][permission.context] ==
          'READER' ||
          permissions[permission.pertinence][permission.section][permission.subsection][permission.context] ==
            'EDITOR' ||
          permissions[permission.pertinence][permission.section][permission.subsection][permission.context] ==
            'MANAGER')
      ) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else if (
        permission.type == 'EDITOR' &&
        permissions[permission.pertinence][permission.section] &&
        permissions[permission.pertinence][permission.section][permission.subsection] &&
        (permissions[permission.pertinence][permission.section][permission.subsection][permission.context] ==
          'EDITOR' ||
          permissions[permission.pertinence][permission.section][permission.subsection][permission.context] ==
            'MANAGER')
      ) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else if (
        permission.type == 'MANAGER' &&
        permissions[permission.pertinence][permission.section][permission.subsection] &&
        permissions[permission.pertinence][permission.section][permission.subsection][permission.context] == 'MANAGER'
      ) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    }
  }
}
